module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('simplert'), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.loading
    },
    on: {
      "update:active": function($event) {
        _vm.loading = $event
      }
    }
  }), _vm._v(" "), _c('nav', {
    staticClass: "nav navbar-skinny navbar navbar-toggleable-md navbar-inverse bg-info"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.toggleSlideoutPanelBtn
    }
  }, [_c('i', {
    staticClass: "icon-Mezzanine_Favicon mezzwings",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Portal")]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbarColor01"
    }
  }, [_c('ul', {
    staticClass: "navbar-nav mr-auto"
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "badge badge-pill badge-light"
  }, [_vm._v(_vm._s(_vm.signedInAs))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('button', {
    staticClass: "signout-button btn btn-primary btn-sm",
    on: {
      "click": _vm.toggleSlideoutPanelBtn
    }
  }, [_c('i', {
    staticClass: "fas fa-bars"
  })]), _vm._v(" "), _c('button', {
    staticClass: "signout-button btn btn-primary btn-sm",
    on: {
      "click": _vm.signOutBtn
    }
  }, [_c('i', {
    staticClass: "fas fa-sign-out-alt"
  })])])])]), _vm._v(" "), _c('vue-slideout-panel', {
    attrs: {
      "widths": ['25%'],
      "closeHtml": "<button class='btn-sm btn-primary'><i class='fas fa-bars'></i></button>"
    },
    on: {
      "close": function($event) {
        _vm.showSlideoutPanel = false
      }
    },
    model: {
      value: (_vm.showSlideoutPanel),
      callback: function($$v) {
        _vm.showSlideoutPanel = $$v
      },
      expression: "showSlideoutPanel"
    }
  }, [_c('h5', {
    staticClass: "text-muted"
  }, [_c('i', {
    staticClass: "icon-Mezzanine_Favicon mezzwings text-primary"
  }), _vm._v(" Portal Features \n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-flush"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#/"
    },
    on: {
      "click": _vm.setSlideoutPanelHidden
    }
  }, [_c('i', {
    staticClass: "fas fa-home"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#/apps"
    },
    on: {
      "click": _vm.setSlideoutPanelHidden
    }
  }, [_c('i', {
    staticClass: "fas fa-mobile-alt"
  }), _vm._v(" Apps")])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#/sync"
    },
    on: {
      "click": _vm.setSlideoutPanelHidden
    }
  }, [_c('i', {
    staticClass: "fas fa-rocket"
  }), _vm._v(" Helium-Journey Sync")])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#/dbspy"
    },
    on: {
      "click": _vm.setSlideoutPanelHidden
    }
  }, [_c('i', {
    staticClass: "fas fa-user-secret"
  }), _vm._v(" DB Spy")])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#/schema-access"
    },
    on: {
      "click": _vm.setSlideoutPanelHidden
    }
  }, [_c('i', {
    staticClass: "fas fa-unlock-alt"
  }), _vm._v(" Schema Access")])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#/support-roster"
    },
    on: {
      "click": _vm.setSlideoutPanelHidden
    }
  }, [_c('i', {
    staticClass: "fas fa-phone"
  }), _vm._v(" Support Roster")])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#/helium-dev-latest"
    },
    on: {
      "click": _vm.setSlideoutPanelHidden
    }
  }, [_c('i', {
    staticClass: "fas fa-download"
  }), _vm._v(" Helium Dev Client")])]), _vm._v(" "), (_vm.isProduction) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#/deployments"
    },
    on: {
      "click": _vm.setSlideoutPanelHidden
    }
  }, [_c('i', {
    staticClass: "fas fa-cloud-upload-alt"
  }), _vm._v(" Deployments")])]) : _vm._e()]), _vm._v(" "), _c('h5', {
    staticClass: "text-muted"
  }, [_c('i', {
    staticClass: "fas fa-external-link-alt text-primary"
  }), _vm._v(" Links")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-flush"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://monitor.heliumapps.com"
    }
  }, [_c('i', {
    staticClass: "fas fa-tv"
  }), _vm._v(" Helium Monitor")])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://wiki.stb.mezzanineware.com/devops-docs/mezzanine-infrastructure/#infrastructure"
    }
  }, [_c('i', {
    staticClass: "fas fa-server"
  }), _vm._v(" Infrastructure docs")])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://wiki.stb.mezzanineware.com/display/HD/Helium+DevOps"
    }
  }, [_c('i', {
    staticClass: "fab fa-wikipedia-w"
  }), _vm._v(" Mezzanine Wiki")])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://wiki.stb.mezzanineware.com/display/HD/Helium+SPE+Support"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Mezzanine Jira")])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "https://mezzanineteams.slack.com"
    }
  }, [_c('i', {
    staticClass: "fab fa-slack"
  }), _vm._v(" Mezzanine Slack channel")])])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "content"
    }
  }, [(!_vm.apps) ? _c('sign-in', {
    staticClass: "signin"
  }) : _vm._e(), _vm._v(" "), (_vm.apps) ? _c('router-view', {
    ref: "homelink"
  }) : _vm._e()], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.modalSignoutVisibile,
      "backdrop": _vm.modalBackdrop,
      "effect": "zoom",
      "large": ""
    },
    on: {
      "update:show": function($event) {
        _vm.modalSignoutVisibile = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n        Sign out\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("\n          Going so soon?\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('button', {
    staticClass: "btn btn-default btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modalSignoutConfirmBtn
    }
  }, [_vm._v("Sign me out!")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modalSignoutCloseBtn
    }
  }, [_vm._v("Nevermind.")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler navbar-toggler-right",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbarColor01",
      "aria-controls": "navbarColor01",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac584036","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 595
// module chunks = 2